import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { mapActions, mapGetters, mapState } from "vuex";
let CompanyMixin = class CompanyMixin extends Vue {
    isSavePending;
    getFromStore;
    updateCompany;
    getMyCompany;
    createCompany;
    get company() {
        return this.getFromStore("mine") || {};
    }
    saveCompany({ noToast = false } = { noToast: false }) {
        let promise;
        if (this.company._id)
            promise = this.updateCompany([this.company._id, this.company, {}]);
        else {
            promise = this.createCompany(this.company);
        }
        return promise.then(result => {
            console.log(result);
            if (noToast)
                return;
            this.$toasted.global.success({
                message: this.$t('Changes saved')
            });
        }).catch(error => {
            if (noToast)
                return;
            this.$toasted.global.error({
                message: this.$t('Error while saving') + error.message,
            });
        });
    }
};
CompanyMixin = __decorate([
    Component({
        methods: {
            ...mapActions('my-company', {
                updateCompany: 'patch',
                getMyCompany: 'get',
                createCompany: 'create',
            })
        },
        computed: {
            ...mapState('my-company', {
                isSavePending: 'isPatchPending'
            }),
            ...mapGetters('my-company', {
                getFromStore: 'get'
            })
        }
    })
], CompanyMixin);
export default CompanyMixin;
